import { ReactNode } from 'react';
import ForgetPasswordEmail from '../../components/ForgetPassword/ForgetPasswordEmail';
import { ForgetPasswordBlocks } from '../../redux/forgetPassword/forgetPasswordSlice';
import { useAppSelector } from '../../redux/hooks';
import ForgetPasswordNewPassword from '../../components/ForgetPassword/ForgetPasswordNewPassword';
import ForgetPasswordSuccess from '../../components/ForgetPassword/ForgetPasswordSuccess';
import AuthPagesLayout from '../../components/Layout/AuthPagesLayout';

const forgetPasswordBlocks: Record<ForgetPasswordBlocks, ReactNode> = {
  email: <ForgetPasswordEmail />,
  password: <ForgetPasswordNewPassword />,
  success: <ForgetPasswordSuccess />,
};

function ForgetPassword() {
  const currentBlock = useAppSelector((state) => state.forgetPassword.block);

  return (
    <AuthPagesLayout xs={currentBlock === ForgetPasswordBlocks.PASSWORD ? 6.5 : 4}>
      {forgetPasswordBlocks[currentBlock]}
    </AuthPagesLayout>
  );
}

export default ForgetPassword;
